import React from "react";
import cat from "./cat.jpg";
import './App.css';

const CatPic = ()=>{
    return (
        <div className="catChild">
          <img className="catJPG" src={cat} alt="cat"/>
        </div>
    );
};

export default CatPic